import { getModuleTranslator } from '@utils/get-module-translator'
import { generateId } from '@utils/id'
import moduleConfig from '../../config'

const __mtc = getModuleTranslator(moduleConfig.translationKey)

export const mobileDeviceRamComponentFieldMap = () => ({
  mobile_device_ram_component: {
    canCreate: true,
    maxCreation: 1,
    title: __mtc('mobile_device_ram_component'),
    fields: [
      {
        key: generateId(),
        paramName: 'totalCapacity',
        name: `${__mtc('total_capacity')}`,
        inputType: 'bytes',
      },
      {
        key: generateId(),
        paramName: 'availableCapacity',
        name: __mtc('available_capacity'),
        inputType: 'bytes',
      },
    ],
  },
})
